export const ROLES = {
  EDIT: "E",
  VIEWONLY: "V",
  OWNER: "O",
};
